module.exports = __webpack_public_path__ + "img/steel-5.cc80820d.jpg";